<template>
  <div>
    <div @click="preview(item.contentId)" class="card-container card-container-padding column-padding uk-width-1-1"
         uk-grid>
      <div style="min-width: 107px" class="uk-width-1-4">
        <img class="card-content-image" :src="item.previewUrl" @error="onError"/>
      </div>
      <div style="max-width: calc(100% - 107px)" class="uk-width-3-4">
        <p v-clampy="2">
          <span v-if="!authorMouseOver" class="card-content-title">{{item.title}}</span>
          <span v-else class="card-content-title-hover">{{item.title}}</span>
        </p>

        <div class="top-padding" ref="mobileContentRef">
          <div v-for="type in types" class="card-content-type uk-display-inline-block">
            <img :src="resolveIcon(type)"/>
          </div>
        </div>
        <div class="top-padding">
          <span v-if="!isAuthorEmptyOrNil(item.author)" style="font-size: 12px">{{$t('general.sharedBy')}}:&nbsp;<span class="card-content-author" @mouseover="setAuthorMouseOver(true)" @mouseleave="setAuthorMouseOver(false)">{{item.author}}</span></span>
        </div>
      </div>
      <div class="top-margin">
        <div class="card-content-description ">
          <p v-clampy="4">{{item.description}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import iconUtil from '../../../../utils/icon-util'
  import Router from '../../../../router/index'
  import * as misc from '../../../../enums/misc'

  const ICON_SIZE_WITH_PADDING = 25
  const ELLIPSIS_ICON = 'ELLIPSIS'

  export default {
    name: 'search-result-item-mobile',
    props: ['item'],
    data() {
      return {
        types: [],
        authorMouseOver: false
      }
    },
    methods: {
      setAuthorMouseOver(val) {
        this.authorMouseOver = val
      },
      onError(e) {
        e.target.src = iconUtil.resolve(misc.ERROR_ICON)
      },
      preview(contentId) {
        Router.push('preview/' + contentId)
      },
      resolveIcon(type) {
        return iconUtil.resolve(type)
      },
      renderTypes() {
        try {
          let width = this.$refs.mobileContentRef.offsetWidth
          let iconsToShow = Math.floor(width / ICON_SIZE_WITH_PADDING)
          this.types = this.item.componentTypes
          if (iconsToShow <= 4) {
            if (this.types.length > iconsToShow) {
              this.types = this.types.slice(0, iconsToShow - 1)
              this.types.push(ELLIPSIS_ICON)
            }
          } else {
            if (this.types.length === 5) { // ux require only 3 icons & the ellipsis to display if there are types
              this.types = this.types.slice(0, 3)
              this.types.push(ELLIPSIS_ICON)
            }
          }
        } catch (err) {
          this.types = []
        }
      },
      isAuthorEmptyOrNil(author) {
        if (author === '<nil>' || null) {
          return true
        }
      }
    },
    mounted() {
      this.renderTypes()
      window.addEventListener('resize', this.renderTypes)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../styles/colours';

  .card-container {
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 15px;
    margin-bottom: 10px;
    &:hover {
      background-color: #ffffff;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
      cursor: pointer;
      .card-content-title {
        text-decoration: underline;
      }
    }
  }

  .card-container.card-container-padding {
    padding: 12px;
  }

  .card-content-title {
    font-size: 14px;
    font-weight: bold;
    color: $content-link-blue;
  }

  .card-content-title-hover {
    font-size: 14px;
    font-weight: bold;
    color: $content-link-blue;
    text-decoration: none;
  }

  .card-content-author {
    font-size: 12px;
    color: $content-link-blue;
    &:hover {
      text-decoration: underline;
    }
  }

  .card-content-type {
    padding-right: 5px;
    max-width: 22px;
    max-height: 20px;
    padding-top: 12px;
  }

  .card-content-description {
    font-size: 12px;
    color: $content-text;
    margin-top: 5px;
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }

  .uk-grid {
    margin-left: 0;
    padding-left: 0;
  }

  .uk-first-column {
    padding-left: 0;
  }

  .uk-first-column.top-margin {
    margin-top: 5px;
  }

  .card-content-image {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    min-width: 107px;
  }

  .top-padding {
    padding-top: 10px;
  }
</style>
